import * as React from "react"
import Svg, { G, Path } from "react-native-svg"
import { Dimensions } from "react-native"

function FetchSuccessImage(props: any) {
    const screenHeight = Dimensions.get('window').height;
    const { width = '90%', height = screenHeight * 0.6, ...rest } = props;
    const svgHeight = screenHeight >= 800 ? screenHeight * 0.6 : screenHeight * 0.7;

    return (
        <Svg
            width={"100%"}
            height={svgHeight}
            viewBox="0 0 360 464"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...rest}
        >
            <G opacity={0.2} fill={props?.color ? props.color : "#1434CB"} stroke="#122FB7">
                <Path
                    opacity={0.2}
                    d="M370.32 234.216c0 102.789-84.475 186.128-188.696 186.128-104.22 0-188.696-83.339-188.696-186.128 0-102.789 84.476-186.128 188.696-186.128 104.221 0 188.696 83.339 188.696 186.128z"
                />
                <Path
                    opacity={0.16}
                    d="M414.427 231.562c0 127.606-104.743 231.062-233.963 231.062S-53.5 359.168-53.5 231.562C-53.5 103.956 51.243.5 180.464.5c129.22 0 233.963 103.456 233.963 231.062z"
                />
                <Path
                    opacity={0.2}
                    d="M317.243 233.369c0 74.34-61.095 134.615-136.475 134.615-75.379 0-136.474-60.275-136.474-134.615 0-74.339 61.095-134.615 136.474-134.615 75.38 0 136.475 60.276 136.475 134.615z"
                />
                <Path
                    opacity={0.2}
                    d="M262.453 234.217c0 44.024-36.182 79.724-80.829 79.724-44.647 0-80.828-35.7-80.828-79.724s36.181-79.725 80.828-79.725c44.647 0 80.829 35.701 80.829 79.725z"
                />
            </G>
        </Svg>
    )
}

export default FetchSuccessImage
